module.exports = __webpack_public_path__ + "img/yfxn.51496551.svg";